import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const BreadcrumbContext = createContext({ ctx: {}, setCtx: () => {} });

export function BreadcrumbProvider({ children }) {
  const [ctx, setCtx] = useState({});
  const value = useMemo(() => ({ ctx, setCtx }), [ctx]);
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
}

export function useBreadcrumbCtx() {
  return useContext(BreadcrumbContext).ctx;
}

// Pages call this once their data is resolved. Cleared on unmount so a
// page without context (e.g. Discover) doesn't inherit stale labels.
export function useSetBreadcrumb(next) {
  const { setCtx } = useContext(BreadcrumbContext);
  const key = JSON.stringify(next ?? {});
  useEffect(() => {
    setCtx(next ?? {});
    return () => setCtx({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
